/**
 * Hooks personalizados para obtener constantes dinámicas del backend
 */
import React from 'react';
import { useQuery } from 'react-query';
import { constantsQueries } from '@/services/constantsService';
/**
 * Hook para obtener constantes de propiedades
 */
export var usePropertyConstants = function () {
    return useQuery(constantsQueries.property());
};
/**
 * Hook para obtener constantes de room types
 */
export var useRoomTypeConstants = function () {
    return useQuery(constantsQueries.roomType());
};
/**
 * Hook para obtener constantes de rate plans
 */
export var useRatePlanConstants = function () {
    return useQuery(constantsQueries.ratePlan());
};
/**
 * Hook para obtener constantes generales
 */
export var useGeneralConstants = function () {
    return useQuery(constantsQueries.general());
};
/**
 * Hook para obtener sugerencias de timezone por país
 */
export var useTimezoneSuggestions = function (countryCode) {
    return useQuery(constantsQueries.timezoneSuggestions(countryCode));
};
/**
 * Hook para obtener sugerencias de currency por país
 */
export var useCurrencySuggestions = function (countryCode) {
    return useQuery(constantsQueries.currencySuggestions(countryCode));
};
/**
 * Hook combinado para formularios de propiedades que necesita múltiples constantes
 */
export var usePropertyFormConstants = function (countryCode) {
    var propertyConstants = usePropertyConstants();
    var timezoneSuggestions = useTimezoneSuggestions(countryCode || '');
    var currencySuggestions = useCurrencySuggestions(countryCode || '');
    // Debug logging
    React.useEffect(function () {
        var _a;
        if ((_a = propertyConstants.data) === null || _a === void 0 ? void 0 : _a.timezones) {
            var limaTimezone = propertyConstants.data.timezones.find(function (tz) { return tz.value.includes('Lima'); });
        }
    }, [propertyConstants.data]);
    return {
        propertyConstants: propertyConstants,
        timezoneSuggestions: timezoneSuggestions,
        currencySuggestions: currencySuggestions,
        isLoading: propertyConstants.isLoading || timezoneSuggestions.isLoading || currencySuggestions.isLoading,
        isError: propertyConstants.isError || timezoneSuggestions.isError || currencySuggestions.isError,
        error: propertyConstants.error || timezoneSuggestions.error || currencySuggestions.error,
    };
};
